export function adjustForEmc3Format(spcContent: string) {
  const htmlContainer = document.createElement("div");
  htmlContainer.innerHTML = spcContent;

  const paragraphs =
    htmlContainer.querySelectorAll<HTMLDetailsElement>("details.paragraph");

  paragraphs.forEach(function (paragraph) {
    paragraph.open = true;
    paragraph.classList.add("disabled");
    const summaryElement = paragraph.querySelector("summary");
    if (summaryElement) {
      summaryElement.classList.add("sectionHeaderTop");
    }
  });

  const subsections = htmlContainer.querySelectorAll<HTMLDetailsElement>(
    "details:not(.paragraph)"
  );

  subsections.forEach(function (subsection) {
    subsection.open = true;
    subsection.classList.add("disabled");
    const summaryElement = subsection.querySelector("summary");
    if (summaryElement) {
      summaryElement.classList.add("sectionHeader2ndLevel");
    }
  });

  return htmlContainer;
}
